import { Threshold } from '@protector/utils/constants';
import { COLOR_OPTIONS } from 'config/style';
import { ChoroplethTypes } from 'core/utils/map/choropleth.models';
import type { MonitoringDetailThreshold } from './monitoring.models';

export const TWO_MINUTES_CACHE = 2 * 60 * 1000;

export const EMPTY_THRESHOLD: MonitoringDetailThreshold = {
  label: Threshold.NONE,
  color: COLOR_OPTIONS.SECONDARY,
  left: -1,
  right: -1
};

export const LEGEND_LAYER_TYPES: ChoroplethTypes[] = [
  ChoroplethTypes.seeds,
  ChoroplethTypes.phenological_stage,
  ChoroplethTypes.nematode,
  ChoroplethTypes.carbon_map
];

export const CHOROPLETH_TYPE_VALUES: ChoroplethTypes[] = Object.values(ChoroplethTypes);
